module.exports = __webpack_public_path__ + "img/ontute.51c19c84.jpg";